/**
 * Due to difference in API structures and actual naming of fields in app,
 * is used a dedicated fields' converter.
 *
 * @param {object} accountPeriod
 * @return {object}
 */
export default (accountPeriod) => {
    return {
        billing_period: accountPeriod?.interval, // Month | Year
        interval: accountPeriod?.interval_count, // 1, 2, ... , 12
        discount: accountPeriod?.interval_discount,
        unit: accountPeriod?.interval_discount_unit,
        license_valid_till: accountPeriod?.license_valid_till,
        interval_bonus: accountPeriod?.interval_bonus,
        interval_bonus_unit: accountPeriod?.interval_bonus_unit
    };
}
